// Main application entry point
import '../styles/application.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '../components/App'

console.log('Vite application loaded!')

// Initialize React application
const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(<App />)
}

// Hot module replacement for development
if (import.meta.hot) {
  import.meta.hot.accept()
}
